import React, {useState} from 'react';
import {Alert, Button} from '@mui/material';
import {useAuth} from '../auth-context';
import {useClient} from '../core/client';

const ImpersonationBanner = () => {
    const { user, impersonator, isImpersonating, login } = useAuth();
    const client = useClient();
    const [loading, setLoading] = useState(false);

    if (!isImpersonating || !impersonator) {
        return null;
    }

    const handleStop = async () => {
        setLoading(true);
        try {
            const { data } = await client.post('/auth/impersonate/stop');
            await login(data);
        } catch (err) {
            // Keep current session if stop fails.
        } finally {
            setLoading(false);
        }
    };

    return (
        <Alert
            severity="warning"
            action={
                <Button color="inherit" size="small" onClick={handleStop} disabled={loading}>
                    {loading ? 'Stopping...' : 'Stop'}
                </Button>
            }
            sx={{ mb: 2 }}
        >
            Impersonating {user?.email || 'user'} as {impersonator.email}.
        </Alert>
    );
};

export default ImpersonationBanner;
